import {
    Model
} from '@vuex-orm/core'
import User from "@/models/User"
export default class Comment extends Model {
    static entity = 'comments'

    static fields() {
        return {
            id: this.attr(null),
            creator_id: this.attr(null),
            creator: this.belongsTo(User, 'creator_id'),
            body: this.attr(null),
            note_id: this.attr(null)
        }
    }


}